/* PELUX · Chantier conversion du 14/10 — zone « stories » de la fiche du harnais
   (thème de test « page parfaite », review/cro-2026-10-14/CHARTE.md).
   Stories et sections suivantes : stories de la colonne d'achat et visionneuse, atouts, bandeau de confiance, moment, bénéfices.
   Chargé en defer seulement sur la fiche du harnais, après pelux-preuve.js (layout/theme.liquid).
   Custom elements ou délégation sur le document : les blocs re-rendus (variantes, prix) remplacent
   leur DOM à chaque changement de variante.

   Deux comportements, sans aucune donnée propre — tout est relu dans la page, à la source :
     1. Barre d'achat de la visionneuse des stories (snippets/pelux-story-achat.liquid) : à chaque
        ouverture, elle reprend la variante cochée en haut de fiche (titre de [data-selected-variant]),
        le prix affiché (bloc de prix, comme la barre collante), la vignette de stock de la taille
        cochée si elle est visible (« Il n'en reste que X », mêmes mots), et le libellé du bouton d'achat principal. « Ajouter » referme la story puis
        actionne CE bouton (même formulaire, même tiroir) ; « Changer » la referme et ramène au choix
        des options. Bouton principal absent ou inactif : pas de barre.
     2. Rappel des stories dans la section « moment » (sections/pelux-moment.liquid) : les visages
        des trois premières stories de la colonne, puis la visionneuse ouverte à la première — le
        focus revient au rappel à la fermeture, la page ne saute pas. Stories absentes ou
        invisibles (lots sur un thème publié) : le rappel reste masqué.
   ⚠️ L'appui sur la barre est intercepté à la CAPTURE : pelux-preuve.js fait passer la story
   suivante à tout appui dans le cadre (texte compris), barre comprise sinon. */
(function () {
  'use strict';

  if (window.peluxCroStories) return;
  window.peluxCroStories = true;

  var REDUIT = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function visible(el) {
    return !!(el && el.getClientRects().length);
  }

  /* ---------------------------------------------------------------------------
     La buybox, source unique : variante cochée, prix, stock, bouton d'achat.
     Après un changement de variante, Dawn garde 500 ms l'ancien <variant-selects> derrière le
     nouveau : querySelector rend le nouveau (inséré avant l'ancien).
     --------------------------------------------------------------------------- */
  function selecteur() {
    return document.querySelector('.product__info-container variant-selects[data-section]') ||
      document.querySelector('.product__info-container variant-selects');
  }

  function boutonPrincipal() {
    var vs = selecteur();
    var b = vs && vs.dataset.section ? document.getElementById('ProductSubmitButton-' + vs.dataset.section) : null;
    return b || document.querySelector('.product__info-container .product-form__submit');
  }

  function libelleVariante() {
    var vs = selecteur();
    if (!vs) return '';
    var json = vs.querySelector('[data-selected-variant]');
    if (json) {
      try {
        var v = JSON.parse(json.textContent);
        if (v && v.title) return String(v.title).split(' / ').join(' · ');
      } catch (e) {
        /* repli : les options cochées */
      }
    }
    var valeurs = [];
    vs.querySelectorAll('input[type="radio"]:checked').forEach(function (i) { valeurs.push(i.value); });
    if (!valeurs.length) vs.querySelectorAll('select').forEach(function (s) { valeurs.push(s.value); });
    return valeurs.join(' · ');
  }

  // Le prix tel que la buybox l'affiche (même lecture que la barre collante).
  function prixAffiche() {
    var bloc = document.querySelector('.product__info-container [id^="price-"][role="status"]') ||
      document.querySelector('[id^="price-"][role="status"]');
    if (!bloc) return '';
    var promo = bloc.querySelector('.price--on-sale');
    var p = bloc.querySelector(promo ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
    return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // La vignette « Il n'en reste que X » de la taille cochée — seulement si elle se voit : un
  // lot masqué (thème publié) n'est jamais recopié.
  function stockAffiche() {
    var vs = selecteur();
    var ruban = vs && vs.querySelector('.pelux-stock-ruban');
    if (!visible(ruban)) return null;
    var bulle = ruban.querySelector('.pelux-stock-ruban__bulle');
    var texte = bulle ? bulle.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!texte) return null;
    return {
      texte: texte,
      lot: ruban.hasAttribute('data-pelux-lot')
    };
  }

  /* ---------------------------------------------------------------------------
     1. Barre d'achat de la visionneuse
     --------------------------------------------------------------------------- */
  function remplir(barre) {
    var vue = barre.closest('dialog');
    var bouton = boutonPrincipal();
    var prix = prixAffiche();
    var actif = !!(bouton && !bouton.disabled && bouton.getAttribute('aria-disabled') !== 'true' && prix);
    barre.hidden = !actif;
    if (vue) vue.classList.toggle('pelux-story-vue--achat', actif);
    if (!actif) return;

    barre.querySelector('[data-story-achat-prix]').textContent = prix;
    barre.querySelector('[data-story-achat-variante]').textContent = libelleVariante();
    var libelle = bouton.querySelector('span');
    var texteBouton = libelle ? libelle.textContent.replace(/\s+/g, ' ').trim() : '';
    if (texteBouton) barre.querySelector('[data-story-acheter]').textContent = texteBouton;

    var zone = barre.querySelector('[data-story-achat-stock]');
    var s = stockAffiche();
    zone.textContent = '';
    zone.removeAttribute('data-pelux-lot');
    if (s) {
      zone.appendChild(document.createTextNode(s.texte));
      if (s.lot) zone.setAttribute('data-pelux-lot', '');
    }
    zone.hidden = !s;
    // Le texte de la story remonte d'autant (pelux-cro-stories.css, --story-achat-h).
    if (vue) vue.style.setProperty('--story-achat-h', (barre.offsetHeight + 10) + 'px');
  }

  function surveiller(barre) {
    var vue = barre.closest('dialog');
    if (!vue || vue.peluxAchat) return;
    vue.peluxAchat = true;
    // Toute ouverture (vignette, rappel du « moment », clavier) passe par l'attribut open.
    new MutationObserver(function () {
      if (vue.open) remplir(barre);
    }).observe(vue, { attributes: true, attributeFilter: ['open'] });
    if (vue.open) remplir(barre);
  }

  function ajouter() {
    var b = boutonPrincipal();
    if (b && !b.disabled) b.click();
  }

  function allerAuChoix() {
    var vs = selecteur();
    if (!vs) return;
    vs.scrollIntoView({ behavior: REDUIT ? 'auto' : 'smooth', block: 'center' });
    var coche = vs.querySelector('input:checked') || vs.querySelector('input, select');
    if (coche) coche.focus({ preventScroll: true });
    vs.classList.add('pelux-cro-vise');
    setTimeout(function () { vs.classList.remove('pelux-cro-vise'); }, 1800);
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    var barre = cible.closest('[data-story-achat]');
    if (!barre) return;
    // Un appui sur la barre ne fait jamais défiler la story (voir l'en-tête).
    e.stopPropagation();
    var acheter = cible.closest('[data-story-acheter]');
    var changer = acheter ? null : cible.closest('[data-story-changer]');
    if (!acheter && !changer) return;
    e.preventDefault();
    var suite = acheter ? ajouter : allerAuChoix;
    var vue = barre.closest('dialog');
    if (vue && vue.open) {
      // Après la fermeture (et le retour du focus à la vignette par pelux-preuve.js) : le tiroir
      // panier ou le choix des options prend ensuite la main.
      vue.addEventListener('close', function () { setTimeout(suite, 0); }, { once: true });
      vue.close();
    } else {
      suite();
    }
  }, true);

  /* ---------------------------------------------------------------------------
     2. Rappel des stories dans la section « moment »
     --------------------------------------------------------------------------- */
  function storiesDeLaFiche() {
    return document.querySelector('.product__info-container pelux-stories') || document.querySelector('pelux-stories');
  }

  function rappels() {
    var boutons = document.querySelectorAll('[data-rappel-stories]');
    if (!boutons.length) return;
    var stories = storiesDeLaFiche();
    var bloc = stories && stories.closest('.pelux-stories');
    if (!stories || !visible(bloc)) return;
    var cartes = stories.querySelectorAll('[data-story]');
    if (!cartes.length) return;
    var lot = bloc.hasAttribute('data-pelux-lot');

    boutons.forEach(function (b) {
      if (b.peluxRappel) return; // déjà prêt (section re-rendue dans l'éditeur de thème)
      b.peluxRappel = true;
      var visages = b.querySelector('[data-rappel-visages]');
      if (visages && !visages.childElementCount) {
        for (var i = 0; i < cartes.length && i < 3; i++) {
          var source = cartes[i].querySelector('img');
          if (!source) continue;
          var img = document.createElement('img');
          img.alt = '';
          img.width = 34;
          img.height = 34;
          img.loading = 'lazy';
          img.decoding = 'async';
          // srcset avant src : le navigateur prend la plus petite image utile (34 px).
          if (source.getAttribute('srcset')) {
            img.setAttribute('sizes', '34px');
            img.setAttribute('srcset', source.getAttribute('srcset'));
          }
          img.src = source.getAttribute('src') || source.currentSrc;
          visages.appendChild(img);
        }
      }
      if (lot) b.setAttribute('data-pelux-lot', '');
      b.hidden = false;
      b.addEventListener('click', function () {
        // Les stories de la page au moment du clic (la colonne d'achat peut avoir été re-rendue).
        var s = storiesDeLaFiche();
        if (!s) return;
        var vue = s.vue;
        if (typeof s.ouvrir === 'function' && vue && typeof vue.showModal === 'function' && s.items && s.items.length) {
          if (!vue.open) s.ouvrir(0, b);
          return;
        }
        var premiere = s.querySelector('[data-story-ouvrir]');
        if (premiere) premiere.click();
      });
    });
  }

  function demarrer() {
    document.querySelectorAll('[data-story-achat]').forEach(surveiller);
    rappels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  // Éditeur de thème : une section re-rendue arrive sans barre ni rappel préparés.
  document.addEventListener('shopify:section:load', demarrer);
})();
